var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.$t('Skill Selector')))]), _c('v-card-text', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "dense": "",
      "label": _vm.$t('Skill Type'),
      "items": _vm.types
    },
    model: {
      value: _vm.type,
      callback: function callback($$v) {
        _vm.type = $$v;
      },
      expression: "type"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "dense": "",
      "label": _vm.$t('Skill Target'),
      "items": _vm.targets
    },
    model: {
      value: _vm.target,
      callback: function callback($$v) {
        _vm.target = $$v;
      },
      expression: "target"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "dense": "",
      "label": _vm.$t('Skill Detail'),
      "items": _vm.attributes
    },
    model: {
      value: _vm.attribute,
      callback: function callback($$v) {
        _vm.attribute = $$v;
      },
      expression: "attribute"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "dense": "",
      "label": _vm.$t('Skill Amount'),
      "items": _vm.values
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  })], 1)], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.push(_vm.evals);
      }
    }
  }, [_vm._v("OK")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }